// Overwrite setting for DEV from local env settings if defined
const isDevEnv = process.env.NODE_ENV === 'development';
const useLocalConfig = isDevEnv && process.env.REACT_APP_USE_LOCAL_CONFIGURATION === 'true';

const envConfig = {
  ...window,
  // Overwrite setting for DEV from local env settings if defined
  ...(useLocalConfig ? process.env : undefined),
} as any;

const basename = envConfig.REACT_APP_SUB_DIRECTORY || '';
const authority = envConfig.REACT_APP_AUTHN_AUTHORITY || '';
const clientId = envConfig.REACT_APP_AUTHN_CLIENTID || 'Questra';
const scope = 'profile offline_access';
const signInRoute = 'signin-oidc';
const signInPopupRoute = 'signin-oidc-popup';
const signOutRoute = 'signout-oidc';
const signOutPopupRoute = 'signin-oidc-popup';

const Config = {
  authority,
  clientId,
  scope,
  responseType: 'code',
  basename,
  signInRoute,
  signInPopupRoute,
  signOutRoute,
  signOutPopupRoute,
  allowResignin: true,
  bypassAuthentication: false,
  auth: {
    authority,
    client_id: clientId,
    scope,
    redirect_uri: `${window.location.origin}${basename}/${signInRoute}`,
    post_logout_redirect_uri: `${window.location.origin}${basename}/${signOutRoute}`,
  },
  domainAdminService: {
    endpoint: envConfig.REACT_APP_API_DOMAIN_ADMIN_SERVICE_URL || '',
  },
  callService: {
    endpoint: envConfig.REACT_APP_API_CALL_SERVICE_URL || '',
    message: envConfig.REACT_APP_CALL_SERVICE_MESSAGE || '',
  },
  language: envConfig.REACT_APP_LANGUAGE || undefined,
};

export default Config;
